import type { ReactNode } from 'react';
import { cn } from '@/utils/classnames';
import { MaterialIcon } from './MaterialIcon';

export interface EmptyStateProps {
  icon?: string;
  title: ReactNode;
  description?: ReactNode;
  /** Optional action — typically a button. */
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon = 'inbox', title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-stack-sm rounded-lg border border-dashed border-outline-variant bg-surface-container-lowest px-container-padding py-container-padding text-center',
        className,
      )}
    >
      <span className="text-on-surface-variant">
        <MaterialIcon name={icon} size={36} />
      </span>
      <h3 className="font-headline-md text-headline-md text-on-surface">{title}</h3>
      {description ? <p className="text-body-sm text-on-surface-variant">{description}</p> : null}
      {action ? <div className="mt-stack-sm">{action}</div> : null}
    </div>
  );
}
